// refreshGrid(calendar-history.js)가 어느 길로 갈지 정하는 순수 함수 (HRGA P5 Task 4 리뷰 3차, R31).
// DOM 도 import 도 없다 — calendar-history.js 와 Node 단위 테스트(tests/unit/refresh-plan.test.mjs)가 같이 쓴다.
//
// planRefresh({hasRoot, crossPath, alive, pending}) → {action, pend}
//  hasRoot   지금 문서에 REFRESH_ROOTS 의 루트가 있다
//  crossPath 부른 쪽이 페이지 통째 교체를 청했다 (navigate 의 경로가 바뀌는 이동)
//  alive     navigate 가 부른 갱신이다 (이동의 생사 확인을 넘겼다)
//  pending   navigate 의 페이지 교체가 아직 끝나지 않았다 (새 화면의 스타일을 기다리는 중)
//  action:
//   'drop' — 교체를 기다리는 동안 들어온 배경 갱신: 순번을 올리지 않고 끝낸다. 곧 올 새 화면이 대신하되,
//            새 화면의 HTML 은 이 갱신보다 먼저 받은 것이므로 교체가 끝난 뒤 한 번 다시 받는다(호출자가 표시).
//   'page' — 페이지 통째 교체(swapPage): 부른 쪽이 청했거나, 루트가 없는 화면이거나, 교체를 기다리는 중에
//            navigate 가 부른 갱신 — 화면은 아직 currentPath 의 페이지가 아니므로 옛 껍데기에 새 루트를 심으면
//            (루트 교체) 두 화면이 섞인다.
//   'root' — 루트 하나만 갈아끼운다 (같은 화면의 다시 그리기).
//  pend: 이 교체를 "기다리는 중" 으로 적어 둔다 — navigate 가 부른 페이지 교체일 때만.
export function planRefresh(o) {
    const s = o || {};
    if (s.pending && !s.crossPath && !s.alive) return { action: 'drop', pend: false };
    const page = !!s.crossPath || !s.hasRoot || (!!s.pending && !!s.alive);
    return { action: page ? 'page' : 'root', pend: page && !!s.alive };
}
